// QZ tray public certs
export const PUBLIC_CERT_LOCAL = `-----BEGIN CERTIFICATE-----
MIIDCTCCAfGgAwIBAgIUXfF0h85+anCSYGog8/cqtpz5Uf8wDQYJKoZIhvcNAQEL
BQAwFDESMBAGA1UEAwwJbG9jYWxob3N0MB4XDTI1MDcyOTAzMzE0MVoXDTM1MDcy
NzAzMzE0MVowFDESMBAGA1UEAwwJbG9jYWxob3N0MIIBIjANBgkqhkiG9w0BAQEF
AAOCAQ8AMIIBCgKCAQEAzHeLgH2yjnrxhSM8fw4q8y1MDBZ8Z7DBLLQN+xZbHp1K
nm0G4/HSHZXjhu8qBsvTmyOcM5W2eXdoP+wyiHa/HaCrJfJ3S16KY6YIsUfVakwz
x7LZxV822lZCdUUmU6jTtvja3xFXCXWKfAde+WGkyhav65IipHWA+yd//1Khooyc
1Tg2IFnav7eiFGowXoUKr8t5gekNGEEeB6pgn3zytwLHxQfCG/2Uxn0iqEQo6BPq
ckZ/uavzC5Q3bXT8pq8e4Tlc3AdWX/ZZCLvGmw056vy4aNx4Hoz2w3wTvK1iwDU9
ZuiYIffoh+Qoe0csu2+29Tf0biQ6MoTGSR0d2kAudwIDAQABo1MwUTAdBgNVHQ4E
FgQU6ZKMJuzmHz/9sI2Kuerqksk+h4YwHwYDVR0jBBgwFoAU6ZKMJuzmHz/9sI2K
uerqksk+h4YwDwYDVR0TAQH/BAUwAwEB/zANBgkqhkiG9w0BAQsFAAOCAQEAgT1R
a8SVNrwtAmkpukEv0VGhaYpkejOiwATl0c9i+0whQHSllRgNLPt5f3PfPuw8ePHs
xC9H6qpkBm8/ts5OrU0O71gjF3t0yidxRyhSKfkUP05AS3YSy7R96CjD/+O0vNcR
O/cRoHlhDiqKqaFVhgA0CFTf5sSQdqhJaxSL1u9LJDnnCvfeb+laxoKkBBE9Fko2
gK3MGhGrtWpFEft51rea3dMpnHQXaXjjD1O7akQ3kowOHqloXQdqNDitQeymYbeO
MwnzisXZcNHtJghpV7NUOXAarTsKnfqpWNieyEmq9oE1LHTMmqgvnjFu+BVmCEP0
glRjeHzOCsDesZwAeA==
-----END CERTIFICATE-----`;
export const PUBLIC_CERT_DEVELOPMENT = `-----BEGIN CERTIFICATE-----
MIIDLTCCAhWgAwIBAgIUCE6QEio6eghi14J64H9XvfztNIEwDQYJKoZIhvcNAQEL
BQAwJjEkMCIGA1UEAwwbcmVzdGF1cmFudC1kZXYudGFibGV0YXAueHl6MB4XDTI1
MDcxMTA3MDIwMVoXDTM1MDcwOTA3MDIwMVowJjEkMCIGA1UEAwwbcmVzdGF1cmFu
dC1kZXYudGFibGV0YXAueHl6MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKC
AQEAgz/ghjVUREyyhP8kUm57cIX8i1a3rNAnuX145VQnR3qR+LhJv/J3HXWy+1uz
WJRPRhtvhBQMhybZ0GTE8rSYIsTfz/2fpBKhUfmeBuMG9TlAgaJe0XXOhWRNdalR
Z0FAVwYovUgihsOWNdpLwfFGbnsm4dytUxejQreddfyUYPeJdZvcDOSPOR9blucW
1VAOmhpUkmi5YG0XNyxQRVWz2r0RUNlWRhf2sWDfGg9dWQqTsIqTwxSAiWuiAyiK
aVoyD01J7Z2Uz3KULo9eSgrPYh+AOlV45fmcfeg74rR7A0NjIzM7H6D369SwZIhx
nz2TF5cby/dDGq3TrSPQ3ubRfQIDAQABo1MwUTAdBgNVHQ4EFgQUW2m5nRB8iWAw
wl+a+aJL/4QA9tIwHwYDVR0jBBgwFoAUW2m5nRB8iWAwwl+a+aJL/4QA9tIwDwYD
VR0TAQH/BAUwAwEB/zANBgkqhkiG9w0BAQsFAAOCAQEAFoMO6ds5rYTsOODQbPDj
lFSEGqHzvjjeMW7m0nJTuHK2H1Ml45lhGh2zwIvF7YzpLv+FFwrqCpDW18pXymU6
kin2wEfh0qROC35fgy5N/oGrkt5e7qr0XS7GJlsF7O2CdN9OEaJ+6ndcO3xRrETC
Afuu6KehYWKNH7MdcnZmZz6EdUNxm64W8ycqleKlHZzox3sKAxYgjMANKvC9PD6e
NYM5VgWZKRKzYp2H+XdUq8SWz24T5UqjJaHiZPEYicKnm/eFBfw41rUf2MhPb4ty
LB5rTIRjLSrPm3by1zwXb0rNAwuh7xfWXu0dYaOx4JPiUWBP5fub7QGZyaRGdoRZ
Tg==
-----END CERTIFICATE-----`;
export const PUBLIC_CERT_STAGE = `-----BEGIN CERTIFICATE-----
MIIDMTCCAhmgAwIBAgIUBh2njQtf/0vD0MaypAO8KHmVn1swDQYJKoZIhvcNAQEL
BQAwKDEmMCQGA1UEAwwdcmVzdGF1cmFudC1zdGFnZS50YWJsZXRhcC54eXowHhcN
MjUwNzIyMDkwMDM4WhcNMzUwNzIwMDkwMDM4WjAoMSYwJAYDVQQDDB1yZXN0YXVy
YW50LXN0YWdlLnRhYmxldGFwLnh5ejCCASIwDQYJKoZIhvcNAQEBBQADggEPADCC
AQoCggEBAKBEBaeSZ2wCMBlUzTX2z7rryZcXc82xsfUJ9IDZH3xluozNSWOetQCr
fMLMIDupOMV84t7hDo97c+K6izvzE3yon1VjpDtGlxNtXYxuh/65OsXJegHZUBtA
BnFKM/gUT6C6D5lLYmn80Uil1xR4F1THZB+esTaUkyWuA9Tq+mf4KzJJ6e8sILIp
j0FZXtmlFxBjW8dC9oT6DZnbVSmyyKv4pXFPjxPYg1Ukex03dEFi2osWhzKpo7vY
uVuPLZcyd/Jmc+lLyxilVS/NXJsx9lIl/+yk5mCJcZKorO0RyPagf1CAGqcff6Z8
CP3vR2OsrXkgGPlxreW7l3M9Lq+GuJsCAwEAAaNTMFEwHQYDVR0OBBYEFHTpixjN
ACqm8NqmqU/Me+Dh5G1WMB8GA1UdIwQYMBaAFHTpixjNACqm8NqmqU/Me+Dh5G1W
MA8GA1UdEwEB/wQFMAMBAf8wDQYJKoZIhvcNAQELBQADggEBACSFiizIiRLAn3rp
Wp4W4jHrrXrSjb9ruQTrV6zaZ00YnvPpeFefQzVo27ohtptHl32Yu94C8caWXISy
JR4pXy0jD+hgci+BLY35qlqXDHDgGHKSSrt3RvVFUTDafBOIhXzXZ8oviPhgE0X/
NuuaHYyxllk6NiLHsW4E5q266U3nrEpGNuZZzPLIdYq4yC2pynG0YJEyXdF/LNT+
KKRnWqx1QoaplvrSCMNlT/CSMCUK5F1xXb5wiQsYLrVGWJI4rf+cc4/q2zKXhqyH
26Czy7omhsYdTRyyQp/pX27iamROt7Kpt8jq3MKHP2zICS2U1M7S1y1ubXbxPHmX
WZipGnE=
-----END CERTIFICATE-----`;
export const PUBLIC_CERT_PRODUCTION = `-----BEGIN CERTIFICATE-----
MIIDJTCCAg2gAwIBAgIUBNhW9xI9oE20uLrjRDKJG+n9JGowDQYJKoZIhvcNAQEL
BQAwIjEgMB4GA1UEAwwXcmVzdGF1cmFudC50YWJsZXRhcC54eXowHhcNMjUwNzIy
MDkwMjA0WhcNMzUwNzIwMDkwMjA0WjAiMSAwHgYDVQQDDBdyZXN0YXVyYW50LnRh
YmxldGFwLnh5ejCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAPP7+nVF
HtbJJkL58OsNsULQclE7jbA65Q677IpZQe+leX1jotwIWdH8ih91FwhKg6gA7Ow3
+XpIwYmLT12NfS0Qd1E6vw3t5WlwKF9hDXF9o+PlAB+3BQSoaY/ANXgLJ63cOswo
2/KGxMIGxIRk/c5DGoS4SadjSTGOVd2/a4nydJ14dHgxxHRdB3iDrR/X8vX9ey9o
2pdDk7B/5EqLRhexDchJ17MThcTG3Vz6RVKCkRad3IXusKrI+UTLGr0VAHhpVC5a
qvcamdHZsi4CHVFgqi0Ua3FYVulgdzawWUYswTwJ8xsb1iPX70yw7NW51rZFNsok
H3XfOZyymLdpsP0CAwEAAaNTMFEwHQYDVR0OBBYEFMaXjiC84ywSWUuTcaJKVTER
mAXTMB8GA1UdIwQYMBaAFMaXjiC84ywSWUuTcaJKVTERmAXTMA8GA1UdEwEB/wQF
MAMBAf8wDQYJKoZIhvcNAQELBQADggEBALowQ13WrRXQMkJmAMcaGOLn5vaRDqU/
NJxrRurkwl//aKRkZRfq6sXfTjIF3Zy1zgDBbofQ1lyEHNHkAlGlHZg8GDl8R/PQ
W44W4mTIY3JkvigQTK6rMeN0qMpA5xI8+4ph+eJDHgDUvUaZIDDKDzc07HceOoZL
MyQM3N86reAjPaGw/5Q2yEy3qBh96svvwuv7+CMH/iRfAibkSjXfH7VOVPm1obSq
yFlU0Co49/EI2qOy7J5D8WOD8NJdoeDB9/+mWAkQmQj9Qv0mwc5OxYuRRk1lmvcT
NLBzUhIRCDGZC0H2/vZmzC0b2arHWVTCNyFahI8C8u6usarQYpGyo4Q=
-----END CERTIFICATE-----`;
